<div #formlyFormContainer class="flex flex-col h-full">
    <ng-container *ngIf="!standalone && formViewModel">
        <div class="flex flex-col h-full overflow-hidden" *transloco="let t">
            <div class="flex flex-row w-full items-center place-content-between pl-4 pr-2 pt-2 pb-4">
                <span class="font-bold">{{ formViewModel.title }}</span>
                <button mat-icon-button (click)="close()">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
            <div class="flex-grow w-full px-4 mat-typography overflow-y-auto">
                <div class="flex flex-col mb-6 space-y-2" *ngIf="formViewModel.description">
                    <div class="text-hint">{{ formViewModel.description }}</div>
                </div>

                <formly-form [model]="model" (modelChange)="onModelChange($event)" [fields]="fields" [options]="options"
                    [form]="form"></formly-form>
            </div>

            @if (v2) { @if(form.invalid && formErrors?.length > 0) {
            <div class="w-full p-4 flex flex-col gap-2 items-end">
                @for (error of formErrors; track error) {

                <mat-error>
                    {{ getErrorMessage(error) }}
                </mat-error>
                }
            </div>
            }

            <div class="flex w-full p-4 gap-4 place-content-end">
                <v2-button-wrapper [text]="t('actions.cancel')" class="w-full md:w-48"
                    (click)="close()"></v2-button-wrapper>
                <div class="flex space-x-4" *ngIf="bottomActions?.length > 0">
                    @for (action of bottomActions; track action.id) {
                    <v2-button-wrapper [text]="action?.text" class="w-full md:w-48" [disabled]="!form.valid || loading"
                        (click)="dispatchExtraAction(action.id)"></v2-button-wrapper>
                    }
                </div>
                <v2-button-wrapper color="primary" [text]="t('actions.save')" [bold]="true" [icon]="'check'"
                    variant="raised" class="w-full md:w-48" [disabled]="!form.valid || loading"
                    (click)="save()"></v2-button-wrapper>
            </div>
            } @else {
            <div class="flex w-full p-4 place-content-between">
                <button mat-button (click)="close()">Cancelar</button>
                <div class="flex space-x-4">
                    <div class="flex space-x-4" *ngIf="bottomActions?.length > 0">
                        <button *ngFor="let action of bottomActions" mat-button color="primary"
                            [disabled]="!form.valid || loading" (click)="dispatchExtraAction(action.id)"
                            cdkFocusInitial>
                            {{ action.text }}
                        </button>
                    </div>
                    <button mat-button color="primary" [disabled]="!form.valid || loading" (click)="save()"
                        cdkFocusInitial>
                        {{ t("actions.save") }}
                    </button>
                </div>
            </div>
            }
        </div>
    </ng-container>

    <formly-form [model]="model" [fields]="fields" [options]="options" [form]="form" *ngIf="standalone"></formly-form>
</div>